import { useState } from 'react';
import { KeyRound } from 'lucide-react';
import { Button, Modal, useToast } from '@/components/ui';
import { ChangePasswordForm } from './ChangePasswordForm';

export function ChangePasswordModal({ onClose }: { onClose: () => void }) {
  const { notify } = useToast();
  const [saving, setSaving] = useState(false);

  return (
    <Modal
      open
      onClose={onClose}
      size="sm"
      title="Change Password"
      description="Other browsers and devices will be signed out"
      icon={<KeyRound size={18} aria-hidden="true" />}
      dismissible={!saving}
      footer={
        <>
          <Button variant="secondary" onClick={onClose} disabled={saving}>
            Cancel
          </Button>
          <Button type="submit" form="change-password-form" loading={saving}>
            Change Password
          </Button>
        </>
      }
    >
      <ChangePasswordForm
        formId="change-password-form"
        onSavingChange={setSaving}
        onChanged={({ otherSessionsRevoked }) => {
          notify({
            tone: 'success',
            title: 'Password changed',
            description:
              otherSessionsRevoked > 0
                ? `You stay signed in here. ${otherSessionsRevoked} other session${otherSessionsRevoked === 1 ? ' was' : 's were'} signed out.`
                : 'You stay signed in on this device.',
          });
          onClose();
        }}
      />
    </Modal>
  );
}
